export const emptyFilter = {
    state: [
        'completed',
    ],
    surveyDataIds: [],
    question: {
        ruleType: 'ruleGroup',
        rules: [],
    },
    campaign: {
        ruleType: 'ruleGroup',
        rules: [],
    },
    responseDate: {
        ruleType: 'ruleGroup',
        rules: [],
    },
}

export const InitPageWidgets = (surveyId, filter, companyNameQuestion, productId) => ({
    aiSummary: {
        request: '/dashboard/summary/generate/SI',
        requestBody: {
            triggerSource: 'dashboard',
            surveyId,
            filter,
            filterString: filter?.surveyDataIds?.join('_') ?? '',
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    salesIntelligenceMatrix: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'EEM',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '00000000-0000-0000-0000-000000000000',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    productId,
                    groupId: '98fa5bc9-7f17-43a5-b7ea-a1907c7a7915',
                    filter,
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    exhibitorsList: {
        request: `/report/v1/${surveyId}/textquestion`,
        requestBody: {
            questionId: companyNameQuestion,
            questionType: 'TX',
            questionOptionId: null,
            filter: {
                state: [
                    'completed',
                ],
                question: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
                campaign: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
                responseDate: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
            },
        },
        gridClass: 'small',
        style: { gridColumn: 9 },
    },
})

export const companyPageWidgets = {
    aiSummary: {
        gridClass: 'wide',
        style: { gridColumnStart: 1, gridRow: 1 },
    },
    salesIntelligenceMatrix: {
        gridClass: 'wide',
        style: { gridColumnStart: 1, gridRow: 2 },
    },
    exhibitorsList: {
        gridClass: 'small',
        style: { gridColumnStart: 9, gridRow: '1 / span 2' },
    },
}

export const exhibitorPageWidgets = (surveyId, surveyDataIds, productId) => ({
    aiSummary: {
        request: '/dashboard/summary/generate/SI',
        requestBody: {
            triggerSource: 'dashboard',
            surveyId,
            filter: { ...emptyFilter, surveyDataIds },
            filterString: surveyDataIds?.join('_') ?? '',
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    EEI: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'EEI',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '00000000-0000-0000-0000-000000000000',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    productId,
                    groupId: '2',
                    filter: { ...emptyFilter, surveyDataIds },
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    ECI: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'ECI',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '00000000-0000-0000-0000-000000000000',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    productId,
                    groupId: '2',
                    filter: { ...emptyFilter, surveyDataIds },
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    NPS: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'avg',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '4578706c-6f72-6951-3131-363000000000',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    groupId: 'a6634de7-7c47-4c21-a3e2-1051f4f398cb',
                    surveyId,
                    productId,
                    filter: { ...emptyFilter, surveyDataIds },
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    LoR: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'avg',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '4578706c-6f72-6951-3131-353700000000',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    groupId: 'bdee2fee-04f8-46fd-bdf8-21c7660e1727',
                    surveyId,
                    productId,
                    filter: { ...emptyFilter, surveyDataIds },
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    objectivesParentPct: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'pct',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '759ec2ee-2e9b-4a58-95ba-f33f4b721fb8',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    groupId: '428b98b9-0359-412e-804d-ce510b81b87d',
                    productId,
                    surveyId,
                    filter: { ...emptyFilter, surveyDataIds },
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    objectives: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'avg',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '4578706c-6f72-6951-3131-343200000000',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    groupId: '428b98b9-0359-412e-804d-ce510b81b87d',
                    parentId: '759ec2ee-2e9b-4a58-95ba-f33f4b721fb8',
                    surveyId,
                    productId,
                    filter: { ...emptyFilter, surveyDataIds },
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    objectivesQuestion: {
        request: '/api/question/759ec2ee-2e9b-4a58-95ba-f33f4b721fb8/7',
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    salesIntelligenceMatrix: {
        request: '/report/v1/dashboard',
        requestBody: {
            widget: [
                {
                    responseType: 'EEM',
                    industry: 'EV',
                    productType: 'TR',
                    surveyType: 'PE',
                    respondentType: 'EX',
                    questionId: '00000000-0000-0000-0000-000000000000',
                    scope: 'product',
                    benchmarkType: 'YOY',
                    productId,
                    surveyId,
                    groupId: '98fa5bc9-7f17-43a5-b7ea-a1907c7a7915',
                    filter: { ...emptyFilter, surveyDataIds },
                },
            ],
        },
        gridClass: 'wide',
        style: { gridColumn: 1 },
    },
    // exhibitorsList: {
    //     request: `/report/v1/${surveyId}/textquestion`,
    //     requestBody: {
    //         questionId: companyNameQuestion,
    //         questionType: 'TX',
    //         questionOptionId: null,
    //         filter: {
    //             state: [
    //                 'completed',
    //             ],
    //             question: {
    //                 ruleType: 'ruleGroup',
    //                 rules: [],
    //             },
    //             campaign: {
    //                 ruleType: 'ruleGroup',
    //                 rules: [],
    //             },
    //             responseDate: {
    //                 ruleType: 'ruleGroup',
    //                 rules: [],
    //             },
    //         },
    //     },
    //     gridClass: 'small',
    //     style: { gridColumn: 9 },
    // },
})

export const exhibitorWidgets = () => ({
    aiSummary: {
        style: { },
    },
    EEI: {
        style: { },
    },
    ECI: {
        style: { },
    },
})

export const initRequests = () => ({
    getSurveys: {
        request: '/survey',
    },
})
